import { get } from 'lodash';
import OauthApi from 'client/api/v2/OauthApi';
import Vue from 'vue';

const initialState = () => ({
  linkingError: '',
  isLoading: false,
});

export const createOauthProviderManagementModule = () => ({
  namespaced: true,
  state: initialState(),
  actions: {
    linkOauthProvider({ dispatch }, oauthProvider) {
      dispatch('setLinkingError', '');
      dispatch('setIsLoading', true);
      OauthApi.createOauthProviderLink(oauthProvider)
        .then((activateUrl) => {
          const oauthUrl = get(activateUrl, 'data.location');
          window.location.assign(oauthUrl);
        })
        .catch((err) => {
          dispatch('setLinkingError', err);
          dispatch('setIsLoading', false);
        });
    },

    unlinkOauthProvider({ dispatch }, oauthProvider) {
      dispatch('setLinkingError', '');
      dispatch('setIsLoading', true);
      OauthApi.deleteOauthProviderLink(oauthProvider)
        .then(() => {
          dispatch('SettingsModule/fetchUserSettings', undefined, { root: true });
          dispatch('AlertModule/triggerSuccessAlert', 'Google account successfully disconnected.', { root: true });
        })
        .catch((err) => {
          dispatch('setLinkingError', err);
          dispatch('AlertModule/triggerErrorAlert', 'Error occurred while disconnecting account', { root: true });
        })
        .finally(() => {
          setTimeout(() => {
            dispatch('setIsLoading', false);
          }, 1000);
        });
    },

    setLinkingError({ commit }, err) {
      commit('SET_LINKING_ERROR', err);
    },

    setIsLoading({ commit }, isLoading = false) {
      commit('SET_IS_LOADING', isLoading);
    },
  },
  mutations: {
    SET_LINKING_ERROR(state, err) {
      Vue.set(state, 'linkingError', err);
    },

    SET_IS_LOADING(state, isLoading) {
      Vue.set(state, 'isLoading', isLoading);
    },
  },
});

export default createOauthProviderManagementModule();
